var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvangard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0H5V40H35V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4089 25.032V34.1498C22.9066 34.1498 24.9319 32.1083 24.9319 29.5909C24.9319 27.0734 22.9089 25.032 20.4089 25.032ZM6.6965 15.6159H6.68945V38.2589H20.4089V34.1499C17.9113 34.1499 15.8859 32.1085 15.8859 29.591C15.8859 27.0736 17.9113 25.0321 20.4089 25.0321V2.04102C12.9183 2.04102 6.83277 8.09668 6.6965 15.6159Z",
    fill: "#014D2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4088 0H5V40H35V0H20.4088ZM34.2951 39.2895H5.70489V0.71048H20.4088V2.04144C27.9911 2.04144 34.1494 8.09473 34.2881 15.614H34.2951V39.2895Z",
    fill: "#014D2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvangard);
export default __webpack_public_path__ + "static/media/avangard.d3541b56af783f77461bc3dcdbb0c1cb.svg";
export { ForwardRef as ReactComponent };